module.exports = __webpack_public_path__ + "static/vicent-marza-21442ea46ff9bad896483ac98cf010ec.jpg";